import { render, staticRenderFns } from "./leed-platinum.kr.vue?vue&type=template&id=0fbaa24e&"
import script from "./leed-platinum.kr.vue?vue&type=script&lang=js&"
export * from "./leed-platinum.kr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports